export default __webpack_public_path__ + "static/media/ryan-hiking.644327fd.jpg";